module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-500-[111]354.14d4ff3.woff2";